import { atom } from 'recoil';

export const successValidator = atom({
  key: 'successValidator',
  default: undefined,
});
